import React from 'react';
import {useStyles} from '../../../../hooks/styles';
import {useAlign} from '../../../../theme/helpers';
import Animated from 'react-native-reanimated';
import {Platform} from 'react-native';

export const iconBottomSpacing = 8;
export const iconRightSpacing = 4;
export const iconWidth = 32;
export const iconHeight = 24;

export const InputIconWrapper: React.FC<any> = ({style, children}) => {
  const align = useAlign();
  const styles = useStyles(() => ({
    container: {
      width: align(iconWidth),
      height: align(iconHeight),
      alignItems: 'center',
      justifyContent: 'center',
      ...(Platform.OS !== 'web'
        ? {
            position: 'absolute',
            bottom: iconBottomSpacing,
            right: iconRightSpacing,
          }
        : null),
    },
  }));

  // У обыного View есть баг с динамическим изменением transform стиля
  return <Animated.View style={[styles.container, style]}>{children}</Animated.View>;
};
